import { render } from "./AddressSummary.vue?vue&type=template&id=b7f04efa"
import script from "./AddressSummary.vue?vue&type=script&lang=js"
export * from "./AddressSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__